import React from 'react';
import { Utils } from '@adobe/aem-react-editable-components';
import Container from '@yme/components/Containers/Container';
export function buildAccordionData(data = [], isRightToLeft) {
    return data.map((item) => ({
        title: item.itemTitle,
        children: React.createElement(Container, { ...Utils.modelToProps(item.content) }),
        isRightToLeft,
    }));
}
